export const sidePanelWidthCollapsed = 48;
export const sidePanelWidthExpanded = 288;
export const spinHeaderHeight = 56;
export const stickyButtonBarHeight = 64;
export const topBarHeight = 56;

export const cardActionsHeight = 64;
export const cardTitleHeight = 64;
